import React, { PureComponent } from 'react'
import { TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core'

import { Tooltip } from 'components'
import { BookingsOptions } from 'components/Bookings/components'

export class BookingsTableHead extends PureComponent {
  createSortHandler = property => e => this.props.requestSort(e, property)

  renderColumn = ({ id, label }) => {
    const { order, orderBy, padding } = this.props

    return (
      <TableCell
        key={id}
        style={{ paddingLeft: 6, paddingRight: 6 }}
        padding={padding}
        sortDirection={orderBy === id ? order : false}
      >
        {id === 'serial'
          ? label
          : <TableSortLabel
            active={orderBy === id}
            onClick={this.createSortHandler(id)}
            direction={order.length > 0 ? order : 'asc'}
          >
            {label}
          </TableSortLabel>}
      </TableCell>
    )
  }

  render() {
    const { onSortResetClick, columnData, padding } = this.props

    return (
      <TableHead>
        <TableRow>

          <TableCell padding={padding}>
            <Tooltip title='Скинути сортування' placement='right'>
              <BookingsOptions onSortResetClick={onSortResetClick} />
            </Tooltip>
          </TableCell>

          {columnData.map(this.renderColumn)}

        </TableRow>
      </TableHead>
    )
  }
}

BookingsTableHead.defaultProps = {
  padding: 'default'
}



// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingsTableHead/BookingsTableHead.js